(() => {
  const dispatch = () => {
    document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    document.dispatchEvent(new CustomEvent('StartKernelLoading'));
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    dispatch();
  } else {
    window.addEventListener('load', dispatch, { once: true });
  }
})();
